export const LAYOUT_COLS = 24;

export const LAYOUT_BREAKPOINTS = {
  desktop: 1024,
  mobile: 1,
};

/**
 * Important: keep the same pdding for x and y.
 */
// export const LAYOUT_PADDING: Record<string, [number, number]> = {
//   desktop: [20, 20],
//   mobile: [8, 8],
// };

/**
 * This is the height of a row in the layout grid.
 */
export const LAYOUT_ROW_HEIGHT = 24;
